import { Navigate, useParams } from "react-router-dom";
import Groups from "./components/Groups";

const ProtectedGroupRoute = () => {
  const token = localStorage.getItem('token');
  const { groupcode } = useParams();
  
  if (!token) {
    return <Navigate to={`/signin?groupCode=${groupcode}`} replace />;
  }

  return <Groups />;
};

export default ProtectedGroupRoute;
